




















































































import DateMixin from "@/mixins/DateMixin";
import AccountIdValdationMixin from "@/mixins/AccountIdValdationMixin";
import { LocaleService } from "@/services/locale.service";
import { DalModule } from "@/store/dal.module";
import { Component, Mixins, Vue } from "vue-property-decorator";
import moment from "moment";

@Component({
  watch: {
    AccountId: "getCounterCheckInfo",
  },
})
export default class AccountInfoView extends Mixins(
  DateMixin,
  AccountIdValdationMixin,
) {
  get AccountId() {
    return DalModule.AccountId;
  }
  get AccountInfo() {
    const x = DalModule.accounts.find((a) => a.account_id == this.AccountId);
    return x;
  }

  async getCounterCheckInfo() {
    await DalModule.getCounterCheckInfo({
      Account_id: this.AccountId,
      Lang: LocaleService.getLocale(),
    });
  }

  get getCounter() {
    const res = DalModule.counterList.find((r) => r.count_type == 4);
    if (
      res &&
      res.date_id &&
      moment(new Date(res.date_id)).format("YYYY-MM-DD") == "1900-01-01"
    )
      res.date_id = null as any;
    return res;
  }

  async mounted() {
    await this.validateAccountId();
    if (!this.$route.params.id) {
      this.$router.push({ name: "account-list" });
      return;
    }
    const acc = Number.parseInt(this.$route.params.id);
    if (acc) {
      DalModule.setAccountId(acc);
      DalModule.setCounterList();
      await this.getCounterCheckInfo();
    }
  }
}
